import React, { createContext, useContext } from 'react';
import { ConfigProvider } from 'antd';
import { Provider } from 'react-redux';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import { antdTheme, GlobalStyle } from './shared/styles/antd-theme';
import { MessageDisplayer } from './shared/components/MessageDisplayer';

import { ThemeProvider } from './app/providers/ThemeProvider';

export const GlobalsContext = createContext(null);

export function useGlobals() {
  const tools = useContext(GlobalsContext);

  return tools;
}

export function GlobalsProvider({ store, tools, children }) {
  const { queryClient } = tools;

  return (
    <GlobalsContext.Provider value={tools}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <ConfigProvider prefixCls="ant-v5" theme={antdTheme}>
              <GlobalStyle />
              <MessageDisplayer />
              {children}
            </ConfigProvider>
          </ThemeProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </Provider>
    </GlobalsContext.Provider>
  );
}
